/* The token an emailed link carries: /verify#token=… and /reset-password#token=….
   index.html moves it out of the fragment into history.state before PostHog
   starts, so no URL analytics records can hold it, and a reload of the page
   still finds it. The fragment is read too, for a page that loaded without
   that script. */

type State = Record<string, unknown> | null;

/** The link's token, or null when the page was opened without one. No side effects: safe in a render. */
export function linkToken(): string | null {
  const kept = (window.history.state as State)?.linkToken;
  if (typeof kept === 'string') return kept;
  return new URLSearchParams(window.location.hash.slice(1)).get('token');
}

/** Keeps `token` for a reload, out of the address bar. */
export function keepLinkToken(token: string): void {
  window.history.replaceState({ ...(window.history.state as State), linkToken: token }, '', window.location.pathname + window.location.search);
}

/** Once the token is spent or dead: gone from the address bar and from this history entry. */
export function forgetLinkToken(): void {
  const { linkToken: _spent, ...rest } = (window.history.state as State) ?? {};
  window.history.replaceState(rest, '', window.location.pathname + window.location.search);
}
